import { Detail } from "components/pages-unit-layanan-aduan/detail";
import { Aduan } from "pages/aduan";
import { ArticleDetail } from "pages/article-detail";
import { ArticleList } from "pages/article-list";
import { Download } from "pages/download";
import { GaleriFotoDetail } from "pages/galeri-foto-detail";
import { GaleriFotoList } from "pages/galeri-foto-list";
import { GaleriVideoList } from "pages/galeri-video-list";
import { Infografis } from "pages/infografis";
import { Informasi } from "pages/informasi";
import { KritikDanSaran } from "pages/kritik-dan-saran";
import { NewsDetail } from "pages/news-detail";
import { NewsList } from "pages/news-list";
import { SurveyKepuasanMasyarakat } from "pages/survey-kepuasan-masyarakat";
import { UnitLayananAduan } from "pages/unit-layanan-aduan";
import { Routes, Route, Link } from "react-router-dom";
import Home from "./pages/home";
import Portal from "./pages/portal";
import { StaticPage } from "./pages/static-page";
import FormDetail from "pages/form-detail";

function App() {
  return (
	<div>
		<Routes>
			<Route exact path="/" element={<Portal />} />
			<Route path="/home" element={<Home />} />
			<Route path="/static/:slug" element={<StaticPage />} />
			<Route path="/informasi/:slug" element={<Informasi />} />
			<Route exact path="/berita" element={<NewsList />} />
			<Route path="/berita/:slug" element={<NewsDetail />} />
			<Route exact path="/artikel" element={<ArticleList />} />
			<Route path="/artikel/:slug" element={<ArticleDetail />} />
			<Route exact path="/galeri-foto" element={<GaleriFotoList />} />
			<Route exact path="/galeri-foto/:judul_galeri_foto" element={<GaleriFotoDetail />} />
			<Route exact path="/galeri-video" element={<GaleriVideoList />} />
			<Route exact path="/galeri-video/:judul_galeri_video" element={<GaleriFotoDetail />} />
			<Route exact path="/infografis" element={<Infografis />} />
			<Route exact path="/download" element={<Download />} />
			<Route exact path="/aduan/:slug" element={<Aduan />} />
			<Route exact path="/unit-layanan-aduan" element={<UnitLayananAduan />} />
			<Route exact path="/unit-layanan-aduan/:slug" element={<Detail />} />
			<Route exact path="/kritik-dan-saran" element={<KritikDanSaran />} />
			<Route exact path="/survey-kepuasan-masyarakat" element={<SurveyKepuasanMasyarakat />} />
			<Route exact path="/form-detail/:id" element={<FormDetail />} />
		</Routes>
	</div>
  );
}

export default App;
